import { CALL_API } from 'redux-api-middleware'
import { authenticate, logout, delegate } from 'utils/network'

// timeout for refresh token
let timeoutID = null

export const authLogin = (credentials) => {
  const request = authenticate(credentials)
  request.types = ['AUTH_REQ', 'AUTH_SUCC', 'AUTH_FAIL']
  return { [CALL_API]: request }
}

export const authLogout = () => {
  clearTimeout(timeoutID)
  const request = logout()
  request.types = ['NOOP', 'AUTH_OUT', 'AUTH_OUT']
  return { [CALL_API]: request }
}

export const authDelegate = () => (dispatch, getState) => {
  const request = delegate()
  request.types = ['NOOP', 'AUTH_REFRESH', '_FAIL']

  return dispatch({
    [CALL_API]: request,
  }).then((res) => {
    if (!res.error) {
      const sec = ((res.payload.jwt_exp * 60) - 30) * 1000 // subtract 30 seconds for allowance
      timeoutID = setTimeout(() => {
        dispatch(authDelegate())
      }, sec)
    } else {
      // check if admin initialized
      // if not, redirect to /login
      if (!getState().app.get('initialized')) {
        return true
      }
      return false
    }
    return false
  })
}



// WEBPACK FOOTER //
// ./src/containers/Auth/actions.js